import React from "react"
import {UxCTA as CTA} from "@next/ux-cta"
import {StyledContainer, StyledBox} from "./component"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"

export const StandardCheckout = props => {
    const {enable} = props
    return (
        <StyledContainer data-testid="header-adaptive-checkout" className="header-adaptive-checkout">
            <StyledBox display={{xs: "none", md: "block"}}>
                <CTA
                    {...props}
                    color="primary"
                    disabled={!enable}
                    state={enable ? "enabled" : "disabled"}
                    variant="contained"
                    size="medium"
                    rel="nofollow"
                    onClick={removeDeptFromSessionStorage}
                />
            </StyledBox>
        </StyledContainer>
    )
}

export default StandardCheckout
